import { AbstractControl, FormArray, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export interface ErrorEntry {
  field: string;
  message: string;
  params: { [key: string]: string };
}

export const gatherErrors = (
  formGroup: UntypedFormGroup,
  errors: ErrorEntry[] = [],
  errorMessageMapping: Record<string, string>,
  errorFieldMapping: Record<string, string>,
): ErrorEntry[] => {
  Object.keys(formGroup.controls).forEach((field: string) => {
    const control: AbstractControl = formGroup.get(field);

    if (control instanceof UntypedFormGroup) {
      gatherErrors(control as UntypedFormGroup, errors, errorMessageMapping, errorFieldMapping);
    } else if (control instanceof FormArray) {
      control.controls.forEach((c: AbstractControl) => gatherErrors(c as UntypedFormGroup, errors, errorMessageMapping, errorFieldMapping));
    } else {
      const control = formGroup.get(field);
      if (control.dirty) {
        const controlErrors: ValidationErrors = control.errors;
        if (controlErrors !== null) {
          Object.entries(controlErrors).forEach(([message, errorValue]) => {
            const params = { [message]: errorValue[message] };
            message = replaceMapping(errorMessageMapping, message);
            field = replaceMapping(errorFieldMapping, field);
            errors.push({ field: field, message: message, params: params });
          });
        }
      }
    }
  });
  return errors;
};

function replaceMapping(mapping: Record<string, string>, value: string): string {
  if (Object.keys(mapping).includes(value)) {
    return mapping[value];
  }
  return value;
}
